/**
 * Investment Holdings React Query Hook
 *
 * Provides data fetching for investment holdings per account.
 */

import { useQuery } from '@tanstack/react-query';
import { bankingService } from '../services/banking-service';

// =============================================================================
// Query Key Factory
// =============================================================================

export const holdingKeys = {
  all: ['holdings'] as const,
  lists: () => [...holdingKeys.all, 'list'] as const,
  list: (accountId: string) => [...holdingKeys.lists(), accountId] as const,
};

// =============================================================================
// Query Hook
// =============================================================================

/**
 * Hook to fetch investment holdings for an account.
 *
 * @param accountId - Account UUID to fetch holdings for (undefined = disabled)
 */
export function useHoldings(accountId: string | undefined) {
  return useQuery({
    queryKey: holdingKeys.list(accountId!),
    queryFn: () => bankingService.getHoldings(accountId!),
    enabled: !!accountId,
  });
}
